﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_informationNoHeaderList from './tpl/informationNoHeaderList.html';
import View_InformationNoHeaderListItem from './informationNoHeaderListItem';

export default Marionette.CollectionView.extend({
    tagName: 'informationNoHeaderList',
    childViewContainer: '#informationNoHeaderList',
    childView: View_InformationNoHeaderListItem,
    getTemplate: function () {
        return tpl_informationNoHeaderList();
    },
    initialize: function () {
        this.listenTo(this.collection, 'change', this.render);
    },
});